import { Box, Button, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Header } from "../components/Header";

const TEAL = "#008080";
const MINT_BG = "#F4F9F8";

interface NotFoundProps {
  title?: string;
  message?: string;
  hideHeader?: boolean;
}

export function NotFound({
  title = "Page not found",
  message = "The page you're looking for doesn't exist or is no longer available.",
  hideHeader = false,
}: NotFoundProps) {
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: MINT_BG }}>
      {!hideHeader && <Header />}
      <Stack spacing={3} alignItems="center" textAlign="center" py={8} px={2}>
        <Typography variant="h4" fontWeight={700} color="#212121">
          {title}
        </Typography>
        <Typography variant="body1" color="#616161" maxWidth={480}>
          {message}
        </Typography>
        <Button
          component={RouterLink}
          to="/"
          variant="contained"
          disableElevation
          sx={{
            bgcolor: TEAL,
            textTransform: "none",
            fontWeight: 600,
            flexDirection: "row",
            "&:hover": { bgcolor: "#006666" },
          }}
        >
          Find a Provider
        </Button>
      </Stack>
    </Box>
  );
}
